exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* StudyEnrollmentForm Style Sheet */\n\n._2XZDVr1if_Hi7B70iNBqPq{\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 23px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    letter-spacing: 0.25px;\n    padding: 2rem 0rem;\n    color: #142A39;\n}\n\n._1iqlr1u4Dt3zg7zKJKg9Z9 {\n    width: 100%;\n    border: 1px solid #142a396c;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 4px;\n    height: 40px;\n    padding: 10px;\n}\n\n._2t8hco5bpNvIc7RsZMvp_b{\n    padding-bottom: 2rem;\n}", ""]);

// exports
exports.locals = {
	"title": "_2XZDVr1if_Hi7B70iNBqPq",
	"testInput": "_1iqlr1u4Dt3zg7zKJKg9Z9",
	"pageContainer": "_2t8hco5bpNvIc7RsZMvp_b"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/StudyEnrollmentForm/StudyEnrollmentForm.styles.module.css
// module id = 10612
// module chunks = 23